import { render, staticRenderFns } from "./ratingMaintenance.vue?vue&type=template&id=71fba952&scoped=true"
import script from "./ratingMaintenance.vue?vue&type=script&lang=js"
export * from "./ratingMaintenance.vue?vue&type=script&lang=js"
import style0 from "./ratingMaintenance.vue?vue&type=style&index=0&id=71fba952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fba952",
  null
  
)

export default component.exports